export default [
  { text: 'Basic proficiency', value: 0 },
  { text: 'Limited working proficiency', value: 1 },
  { text: 'Professional working proficiency', value: 2 },
  { text: 'Mother tongue', value: 3 }
]
